export default "/assets/images/pretend-im-not-even-here.e194190ca1829dac.png";